    //DO NOT REMOVE - DRIVES REVENUE
      var AddShoppersWidgetOptions = { loadCss: false, pushResponse: false };
      !(function () {
        var t = document.createElement('script');
        (t.type = 'text/javascript'),
          (t.async = !0),
          (t.id = 'AddShoppers'),
          (t.src = 'https://shop.pe/widget/widget_async.js#605a2bfebbddbd214f849ea2'),
          document.getElementsByTagName('head')[0].appendChild(t);
      })();